import React, { useState, Fragment } from "react";
import { Button, Icon, Dropdown, FormGroup } from "xsolla-uikit";
import { Link } from "react-router-dom";
import PAh2 from "../PAh2";
import styled from "styled-components";

export function PAcard(props) {

  const {
    inProgress,
    index = 0,
    handlePop = () => void 0,
    size = "md",
    badgeText = false, //steam uses this solution,false
    title = "Title",
    description = "Short Description",
    descrLong,
    // descrLong = "Long Descript ion",
    // img = "https://assets.website-files.com/5d303aa1e8832120171290c0/5d36ec9631adeb60604a357d_17698.jpg",
    image,
    link,
    learnMoreUrl = "/",
    icon,
    intTime = "less than 3 minutes",
    intStep0 = "",
    intStep1 = "",
    intStep2 = "",
    intStep3 = "",
    intStep4 = "",
    intStep5 = "",
    callToAction__title,
  } = {...props};

  const [state, setState] = useState({
    assign: false,
  });
  const [popState, setPopState] = useState(false);

  return (
    <CSScard0
      className="p_x_sol_item_inner"
      style={{
        minHeight: 380,
        // width: 310,
      }}
    >
      <CSScard
      // className="p_content-block p_content-block--sol"
      >
        <div className="p_x_card_z" />
        <a href="#pa-3-int1" className="p_x_card_click w-inline-block" />

        {size === "sm" && <div style={{ height: 40 }} />}

        {size === "md" && (
          <div
            className="p_head_pic0 p_head_pic0--top p_head_pic0--top--sm"
            style={{
              borderRadius: "4px 4px 0px 0px",
            }}
          >
            <div className="p_img_placeholder">
              {!image && size === "md" && (
                <div className="">
                  <div className="p_icon w-condition-invisible w-embed">
                    {!!icon && icon}
                  </div>
                  <div className="p_icon w-embed">
                    <svg width={80} height={80} viewBox="0 0 43 42">
                      <path
                        fill="currentColor"
                        fillRule="nonzero"
                        d="M28.375 34.655a1 1 0 0 1 .374.416l1.751 3.628 1.751-3.628a1 1 0 0 1 .374-.416l3.477-2.155-3.477-2.155a1 1 0 0 1-.374-.416L30.5 26.301l-1.751 3.628a1 1 0 0 1-.374.416L24.898 32.5l3.477 2.155zM16 23.874A4.002 4.002 0 0 1 13 20a1 1 0 0 1 2 0 2 2 0 1 0 2-2 4 4 0 0 1-1-7.874V9a1 1 0 0 1 2 0v1.126c1.725.444 3 2.01 3 3.874a1 1 0 0 1-2 0 2 2 0 1 0-2 2 4 4 0 0 1 1 7.874V25a1 1 0 0 1-2 0v-1.126zm6.473 9.476a1 1 0 0 1 0-1.7l4.601-2.852 2.525-5.233a1 1 0 0 1 1.802 0l2.525 5.233 4.6 2.852a1 1 0 0 1 0 1.7l-4.6 2.852-2.525 5.233a1 1 0 0 1-1.802 0l-2.525-5.233-4.6-2.852zm8.015-15.491a1 1 0 0 1 0-1.718l3.304-1.971 1.814-3.618a1 1 0 0 1 1.788 0l1.814 3.618 3.304 1.971a1 1 0 0 1 0 1.718l-3.304 1.971-1.814 3.618a1 1 0 0 1-1.788 0l-1.814-3.618-3.304-1.971zm4.58.404a1 1 0 0 1 .381.41L36.5 20.77l1.05-2.096a1 1 0 0 1 .382-.41L40.048 17l-2.116-1.263a1 1 0 0 1-.381-.41L36.5 13.23l-1.05 2.096a1 1 0 0 1-.382.41L32.952 17l2.116 1.263zm-15.465 13.53a1 1 0 1 1 .327 1.974C11.107 35.227 2.637 29.692.5 21.063c-2.14-8.632 2.78-17.441 11.28-20.212 8.5-2.77 17.714 1.427 21.144 9.634a1 1 0 0 1-1.846.771C28.05 4.012 19.91.304 12.4 2.752 4.893 5.2.554 12.97 2.44 20.582c1.887 7.614 9.367 12.502 17.163 11.212zm6.247-8.767a1 1 0 0 1 1.682 1.082c-3.266 5.074-9.555 7.186-15.16 5.086-5.598-2.097-9.024-7.84-8.268-13.843.757-6.006 5.5-10.69 11.442-11.287 5.944-.598 11.502 3.053 13.403 8.795a1 1 0 0 1-1.898.629C25.443 8.63 20.753 5.55 15.746 6.054c-5.01.503-9.017 4.46-9.658 9.547-.64 5.089 2.26 9.95 6.986 11.72 4.72 1.77 10.018-.01 12.776-4.295z"
                      />
                    </svg>
                  </div>
                </div>
              )}

              <div className="p_spacer_image p_spacer_image--sm" />
            </div>

            {image && size === "md" && (
              <div
                style={{
                  backgroundImage: `url(${image})`,
                }}
                className="p_img"
              />
            )}
          </div>
        )}

        <div style={{
          flexGrow:1,
          padding: "0 24px 0 24px",}}>



        {/* {!!badgeText && ( */}
          <FormGroup indentation="xs">
            <div
              className="p_modal_badge p_modal_badge--sm"
              style={{
                color: "#0073f7",
                backgroundColor: "transparent",
                padding: "0 0 0 0px",
              }}
            >
              {badgeText}
            </div>
          </FormGroup>
        {/* )} */}

        <FormGroup indentation="xs">



            <PAh2 tag="h3" indentation="xs" title={title} wrap="normal" /> 

              <FormGroup indentation="md">
                  <div className="p_x_descr p_x_descr--sm w-richtext"
                    style={{color:'#333'}}
                  >
                    {description}
                  </div>
                </FormGroup>

                <div className="p_x_int_time">
                          <div>
                            {intTime && (<div
                              style={{color:'#747e8a'}}
                            >
                              Integration time: <strong>{intTime}</strong>
                            </div>)}
                          </div>
                        </div>

                <FormGroup indentation='sm'>
            <div
              style={{
                // padding: "8px 24px 0px 24px",
              }}
            >
              <div className="p_formgroup_xs">
                <div
                // className="p_comp_int-ctas"
                >
                  <div className="x_flex x_flex--space x_flex--4center">
                    <div
                      // className="p_x_button-negative"
                      style={{
                        width: "100%",
                      }}
                    >
                      <div
                        className="p_x_start"
                        style={{
                          width: "100%",
                          paddingTop: "16px",
                        }}
                      >
                        <FormGroup indentation="sm">
                          <div
                            className="l_flex l_flex--left"
                            style={{ width: "100%" }}
                          >
                            {!inProgress && (
                              <Link
                                to={link}
                                className="p_button"
                                style={{
                                  backgroundColor: "#0073f7",
                                  borderRadius: 4,
                                  boxShadow: "0 3px 6px -4px #0073f7",
                                }}
                              >
                                {!!callToAction__title && <div>{callToAction__title}</div>}
                                {!callToAction__title && <div>Integrate</div>}
                              </Link>
                            )}
                            {inProgress && (
                              <Link
                                to={link}
                                className="p_button p_button--sm"
                                style={{
                                  backgroundColor: "#ffc500",
                                  boxShadow: "0 3px 6px -4px #ffc500",
                                  borderRadius: 4,
                                }}
                              >
                                <div>Finish setup</div>
                              </Link>
                            )}
                            &nbsp;&nbsp;&nbsp;
                            {descrLong && (
                              <div className="p_x_learnmore">
                                <Button appearance="flatten"
                                  // icon="new-tab"
                                  >
                                  Learn more
                                </Button>
                              </div>
                            )}
                            {/* <AssignDropdown/> */}
                          </div>
                        </FormGroup>



                      </div>
                    </div>

                    {/* <div className="p_x_right p_x_right--moved">

                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          </FormGroup>




</FormGroup>
</div>


        <FormGroup>

          <div
            style={{
              width: "100%",
              padding: "16px 24px 16px 24px",
              backgroundColor: "#fafbfc",
              // opacity: 0.4
            }}
          >
            <FormGroup indentation="sm">
              <FormGroup indentation="sm">
                <Button appearance="flatten"
                // icon="transaction"
                >
                  Assign to co-worker
                </Button>
              </FormGroup>
              <FormGroup indentation="xs">
                <Button
                  appearance="flatten"
                  // icon="remove"
                  style={{ color: "#a0abb8" }}
                >
                  I'm not interested
                </Button>
              </FormGroup>
            </FormGroup>
          </div>
        </FormGroup>


      </CSScard>

      {/* <CSScardBecause>You see this because you could earn more by selling your game in South Korea</CSScardBecause> */}
    </CSScard0>
  );
}

const AssignDropdown = ({ setPopState, handlePop, index }) => (
  <Fragment>
    <Dropdown
      align="right-half-back"
      position="top"
      size="sm"
      autosize={"md"}
      options={[
        {
          label: "I'm not interested",
          value: 0,
          // description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
        },
        {
          label: "Contact account manager",
          value: 1,
          // description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
        },
        {
          label: "Assign to co-worker",
          value: 2,
          // description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
        },
      ]}
    >
      <div style={{ color: "#c5d0db" }} appearance="flatten">
        <Icon name="more" />
      </div>
    </Dropdown>

    {/* &nbsp;&nbsp;&nbsp;&nbsp; */}

    <Button
      appearance="flatten"
      size="sm"
      onClick={() => {
        setPopState(true);
        handlePop(index);
      }}
    >
      Learn more
    </Button>
  </Fragment>
);

const CSScardBecause = styled.div`
  padding-top: 0.8em;
  color: rgba(255, 255, 255, 0.59);
  font-size: 13px;
  line-height: 1.2em;
`;

const CSScard0 = styled.div`
  margin-bottom: 8px;
  &:hover {
    z-index: 10;
  }
`;

const CSScard = styled.div`
  background: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  position: relative;
`;
